<div class="global-header d-flex flex-column flex-sm-row p-1 bg-white border-bottom rounded" style="height: auto;">
    <div class="col-12">
        <ul class="nav custom-nav">
            <li class="nav-item">
                <a
                        class="nav-link"
                        [ngClass]="{'active': selectedTab === 'devis'}"
                        [routerLink]="reference ? ['/tiers/clients/details', reference, 'detail-contenue-document', 'devis'] : ['/tiers/clients']"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        (click)="selectTab('devis')"
                >
                    <i data-feather="dollar-sign" class="nav-icon"></i>
                    Devis
                </a>
            </li>
            <li class="nav-item">
                <a
                        class="nav-link"
                        [ngClass]="{'active': selectedTab === 'commande-client'}"
                        [routerLink]="reference ? ['/tiers/clients/details', reference, 'detail-contenue-document', 'commande-client'] : ['/tiers/clients']"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        (click)="selectTab('commande-client')"
                >
                    <i class="bi bi-cart-plus"></i> Commande client
                </a>
            </li>
            <li class="nav-item">
                <a
                        class="nav-link"
                        [ngClass]="{'active': selectedTab === 'bon-livraison'}"
                        [routerLink]="reference ? ['/tiers/clients/details', reference, 'detail-contenue-document', 'bon-livraison'] : ['/tiers/clients']"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        (click)="selectTab('bon-livraison')"
                >
                    <i class="bi bi-truck"></i> Bon de livraison
                </a>
            </li>
            <li class="nav-item">
                <a
                        class="nav-link"
                        [ngClass]="{'active': selectedTab === 'facture'}"
                        [routerLink]="reference ? ['/tiers/clients/details', reference, 'detail-contenue-document', 'facture'] : ['/tiers/clients']"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        (click)="selectTab('facture')"
                >
                    <i data-feather="file" class="nav-icon"></i> Facture
                </a>
            </li>
            <li class="nav-item">
                <a
                        class="nav-link"
                        [ngClass]="{'active': selectedTab === 'bon-sortie'}"
                        [routerLink]="reference ? ['/tiers/clients/details', reference, 'detail-contenue-document', 'bon-sortie'] : ['/tiers/clients']"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        (click)="selectTab('bon-sortie')"
                >
                    <i class="bi bi-file-earmark-arrow-down"></i> Bon de sortie
                </a>
            </li>
        </ul>
        <div class="container-fluid" style="padding: 0; width: 100%; max-width: 100%;">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
